import Vue from 'vue'
import Router from 'vue-router'
import { setFadeOutBody } from '@/common/utils/common'
import memberRoutes from '@/router/memberRoutes'
import adultRoutes from '@/router/adultRoutes'
import otherRoutes from '@/router/otherRoutes'
import errorRoutes from '@/router/errorRoutes'
import settingRoutes from '@/router/settingRoutes'
import categoryRoutes from '@/router/categoryRoutes'
import myRoutes from '@/router/myRoutes'
import listRoutes from '@/router/listRoutes'
import customerRoutes from '@/router/customerRoutes'
import voucherRoutes from '@/router/voucherRoutes'
import playerRoutes from '@/router/playerRoutes'
import accountRoutes from '@/router/accountRoutes'
import searchRoutes from '@/router/searchRoutes'
import redirectRoutes from '@/router/redirectRoutes'
import otherInTheMainLayoutRoutes from '@/router/otherInTheMainLayoutRoutes'
import conferenceRoutes from '@/router/conferenceRoutes'
import astroRoutes from '@/router/astroRoutes'
import companyCustomerRoutes from '@/router/companyCustomerRoutes'
import termsRoutes from '@/router/termsRoutes'
import streamRoutes from '@/router/streamRoutes'
import homeRoutes from '@/router/homeRoutes'
import listViewMoreRoutes from '@/router/listViewMoreRoutes'
import partnerConnectionRoutes from '@/router/partnerConnectionRoutes'
import playgroundRoutes from '@/router/playgroundRoutes'
import {
  PATH_NAME_PLAYER_STREAM,
  PATH_NAME_HOME,
  PATH_NAME_SEARCH,
  PATH_NAME_SUBSCRIPTION_TICKET,
  PATH_NAME_PLAYER_VOD,
  PATH_NAME_PLAYER_MOVIE,
} from '@/common/resources/router.const'
import revocationPromotionRoutes from '@/router/revocationPromotionRoutes'
import { showDeferredInAppMessage } from '@/common/utils/braze.util'

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      components: {
        mainLayout: () => import('@/pages/section/MainLayout'),
      },
      children: [
        // header, app-footer O
        ...homeRoutes,
        ...categoryRoutes,
        ...listViewMoreRoutes,
        ...myRoutes,
        ...listRoutes,
        ...customerRoutes,
        ...voucherRoutes,
        ...playerRoutes,
        ...accountRoutes,
        ...searchRoutes,
        ...redirectRoutes,
        ...otherInTheMainLayoutRoutes,
        // ...baseballRoutes,
      ],
    },
    ...conferenceRoutes,
    ...astroRoutes,
    // header, app-footer X
    ...memberRoutes,
    ...adultRoutes,
    ...settingRoutes,
    ...otherRoutes,
    ...companyCustomerRoutes,
    ...termsRoutes,
    ...errorRoutes,
    ...streamRoutes,
    ...partnerConnectionRoutes,
    ...revocationPromotionRoutes,
    ...playgroundRoutes,
  ],
})

router.beforeEach(async (to, from, next) => {
  if (to.name === PATH_NAME_PLAYER_STREAM) {
    await setFadeOutBody()
  }
  // 특정 라우트에서만 브레이즈의 in-app message 노출 (https://contentwavve.atlassian.net/wiki/spaces/SVCP/pages/1408893078/Braze+In-App+Message)
  const allowedIAMRouteNameList = [
    PATH_NAME_HOME,
    PATH_NAME_SEARCH,
    PATH_NAME_SUBSCRIPTION_TICKET,
    PATH_NAME_PLAYER_VOD,
    PATH_NAME_PLAYER_MOVIE,
  ]
  if (allowedIAMRouteNameList.includes(to.name)) {
    showDeferredInAppMessage()
  }
  next()
})
export default router
